import React, { useEffect, useState } from "react";
import { api, fmtCAD } from "@/lib/api";

export default function AdminOrders() {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/admin/orders").then((r) => setRows(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-extrabold mb-8">Commandes</h1>
      <div className="bg-white border border-gray-200 overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50 text-left text-gray-500"><tr>
            <th className="p-4">Commande</th><th className="p-4">Date</th><th className="p-4">Client</th><th className="p-4">Courriel</th><th className="p-4">Total</th><th className="p-4">Statut</th><th className="p-4"></th>
          </tr></thead>
          <tbody>
            {rows.map((o) => (
              <React.Fragment key={o.id}>
                <tr className="border-t border-gray-100" data-testid={`order-row-${o.order_number}`}>
                  <td className="p-4 font-medium">{o.order_number}</td>
                  <td className="p-4 text-gray-500">{new Date(o.created_at).toLocaleDateString("fr-CA")}</td>
                  <td className="p-4">{o.customer?.name}</td>
                  <td className="p-4 text-gray-500">{o.customer?.email}</td>
                  <td className="p-4 font-semibold">{fmtCAD(o.subtotal)}</td>
                  <td className="p-4"><span className={`px-2 py-1 text-xs font-medium ${o.payment_status === "paid" ? "bg-green-100 text-green-700" : "bg-amber-100 text-amber-700"}`}>{o.payment_status === "paid" ? "Payé" : o.payment_status === "expired" ? "Expiré" : "En attente"}</span></td>
                  <td className="p-4"><button onClick={() => setOpen(open === o.id ? null : o.id)} className="text-sapphire font-medium">{open === o.id ? "Fermer" : "Détails"}</button></td>
                </tr>
                {open === o.id && (
                  <tr className="bg-gray-50"><td colSpan={7} className="p-4">
                    <div className="text-xs text-gray-600 mb-2">Tél : {o.customer?.phone || "—"} · Adresse : {o.customer?.address || "—"}</div>
                    <table className="w-full text-xs bg-white border border-gray-200">
                      <thead className="text-gray-500"><tr><th className="p-2 text-left">Article</th><th className="p-2">Réf</th><th className="p-2">Qté</th><th className="p-2">Prix</th></tr></thead>
                      <tbody>{o.items.map((it, i) => <tr key={`${it.product_id || it.sku || 'item'}-${i}`} className="border-t border-gray-100"><td className="p-2">{it.title}</td><td className="p-2 text-center">{it.sku || "—"}</td><td className="p-2 text-center">{it.quantity}</td><td className="p-2 text-right">{fmtCAD(it.price)}</td></tr>)}</tbody>
                    </table>
                  </td></tr>
                )}
              </React.Fragment>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="p-8 text-center text-gray-400">Aucune commande.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
